export enum DocumentTypeEnum {
    ID = 'ID',
    DocumentId = 'Document Id',
    RevisionId = 'Document Revision Id',
    BuildingId = 'Building Id',
    InsuranceId = 'Insurance Id',
    LotId = 'Lot Id',
    MeetingId = 'Meeting Id',
    ContactId = 'Contact Id',
    UserId = 'User Id'
}
